export * from "./multiRenderTarget.pure";

import "../../Engines/Extensions/engine.multiRender";
